angular.module('core')
  .factory('mailApi', ['http', function (http) {
    return {
      checkAddress: function (address) {
        return http().get('/api/mail/check-email-address', { params: { address: address } });
      }
    };
  }]);
